import store from '@/store'

/**
 * 处理菜单数据，将其转换为包含顶部菜单和侧边栏菜单的结构
 * @param {Array} menuList - 原始菜单数据数组
 * @returns {Object} - 包含 topMenu 和 sideMenu 的对象
 */
const processMenuData = (menuList) => {
  const result = {
    topMenu: [],
    sideMenu: {}
  };

  // 构建菜单映射，方便快速查找
  const menuMap = {};
  menuList.forEach(item => {
    menuMap[item.id] = { ...item, children: item.children || [] };
  });

  // 构建菜单层级关系
  menuList.forEach(item => {
    const menuItem = menuMap[item.id];
    if (item.parentId === '0') {
      // 顶部菜单
      result.topMenu.push(menuItem);
    } else {
      const parent = menuMap[item.parentId];
      if (parent) {
        parent.children.push(menuItem);
      }
    }
  });

  // 构建侧边栏菜单映射
  result.topMenu.forEach(topItem => {
    result.sideMenu[topItem.id] = topItem;
  });

  return result;
};

function findLevel3Menus(menuData) {
  const level3Menus = [];

  // 递归遍历菜单数据
  function traverse(menu, parentNames = [], rootMenuId = null) {
    // 如果是 level=1 的菜单，更新 rootMenuId
    if (menu.level === 1) {
      rootMenuId = menu.id;
    }

    if (menu.level === 3) {
      level3Menus.push({
        path: parentNames.concat(menu.name).join(' -> '),
        data: {
          ...menu,
          rootMenuId // 添加level=1的菜单ID
        }
      });
    }

    if (menu.children && menu.children.length > 0) {
      menu.children.forEach(child => {
        traverse(child, [...parentNames, menu.name], rootMenuId);
      });
    }
  }

  // 遍历所有顶级菜单
  menuData.forEach(menu => {
    traverse(menu);
  });

  return level3Menus;
}

// 处理菜单跳转逻辑
function processMenuNavigation() {
  let menuData = store.state.menuNewList;
  const level3Menus = findLevel3Menus(menuData);
  
  // 按顺序处理每个三级菜单
  for (let i = 0; i < level3Menus.length; i++) {
    const currentMenu = level3Menus[i];
    
    // 模拟检查菜单是否存在
    // 这里假设如果菜单的id以"20000"开头就认为存在
    const menuExists = currentMenu.data.id.startsWith('20000'); // 替换为实际的检查逻辑
    
    if (!menuExists) {
      console.log(`菜单 ${currentMenu.path} 不存在，尝试下一个菜单...`);
      
      // 尝试下一个菜单
      if (i + 1 < level3Menus.length) {
        const nextMenu = level3Menus[i + 1];
        console.log(`跳转到 ${nextMenu.path}`);
        // 这里可以执行实际的跳转操作
        return nextMenu; // 返回下一个菜单并停止处理
      } else {
        console.log('没有更多三级菜单可供跳转');
        return null;
      }
    } else {
      console.log(`访问菜单: ${currentMenu.path}`);
      // 这里可以执行实际的访问操作
      return currentMenu; // 返回当前菜单并停止处理
    }
  }
  
  return '403';
}

// 检查是否存在"自定义报表"菜单
function hasCustomReportMenu() {
  let menuData = store.state.menuNewList;
  // 查找level=1且name="自定义报表"的菜单
  return menuData.some(menu => 
    menu.level === 1 && menu.name === "自定义报表"
  );
}

/**
 * 通过一级菜单name，去找该一级菜单下的三级菜单
 * @param {*} firstLevelName 一级菜单 name
 * @returns 
 */
function findFirstThirdLevelMenu(firstLevelName) {
  let menuData = store.state.menuNewList;
  // 1. 查找匹配的一级菜单
  const firstLevelMenu = menuData.find(menu => menu.name === firstLevelName);
  if (!firstLevelMenu || !firstLevelMenu.children) {
      return null; // 没有一级菜单或没有子菜单
  }

  // 2. 获取第一个二级菜单
  const secondLevelMenu = firstLevelMenu.children[0];
  if (!secondLevelMenu) {
      return null; // 没有二级菜单
  }

  // 3. 检查是否有三级菜单
  if (secondLevelMenu.children && secondLevelMenu.children.length > 0) {
      return secondLevelMenu.children[0]; // 返回第一个三级菜单
  } else {
      return secondLevelMenu; // 如果没有三级菜单，返回二级菜单
  }
}


export {
  processMenuData,
  processMenuNavigation,
  hasCustomReportMenu,
  findFirstThirdLevelMenu
};